import { TimezonesService, ITimezone } from "../../../services/timezone.service";
import { SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/salaryScaleGroup.service";
import { HourCodeService, IHourCode } from "../../../services/hourCode.service";
import * as moment from "moment";

interface IResolve {
    timezone: ITimezone;
    hourCodes: IHourCode[];
}

class TimezonesItemBasicController {

    private resolve: IResolve;
    private timezone: ITimezone;
    hourCodes: IHourCode[] = [];
    salaryScaleGroups: ISalaryScaleGroup[] = [];
    private close: any;

    private type: string;
    private types = [
        'Dagelijks', 'Dag van de week', 'Vaste dag elk jaar', 'Eenmalig'
    ]

    private months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    private weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

    private from: {month?: string, day?: number, time?: any, weekDay?: string, year?: string} = {};
    private till: {month?: string, day?: number, time?: any, weekDay?: string, year?: string} = {};

    constructor(
        private TimezonesService: TimezonesService,
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private HourCodeService: HourCodeService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {        
        if (this.resolve.timezone) {
            this.timezone = this.resolve.timezone;
            // Laad hourCodes voor de CAO van deze timezone
            if (this.timezone.salaryScaleGroupId) {
                this.loadHourCodes(this.timezone.salaryScaleGroupId);
            } else if (this.resolve.hourCodes && this.resolve.hourCodes.length > 0) {
                // Fallback: gebruik hourCodes uit resolve als er geen CAO is
                this.hourCodes = this.resolve.hourCodes;
            }
        } else {
            this.timezone = new ITimezone();
            // Get caoId from state params if available (for new timezones)
            const caoId = this.$stateParams['caoId'];
            this.timezone = {
                from: null,
                till: null,
                percentage: 0,
                amount: 0,
                priority: 0,
                dayOfWeek: 0,
                fixedDate: false,
                fixedDateWithoutYear: false,
                salaryScaleGroupId: caoId || null,
            }
            // Laad hourCodes als er een CAO is
            if (caoId) {
                this.loadHourCodes(caoId);
            } else if (this.resolve.hourCodes && this.resolve.hourCodes.length > 0) {
                // Fallback: gebruik hourCodes uit resolve
                this.hourCodes = this.resolve.hourCodes;
            }
        }

        // Load salary scale groups
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            // Sort alphabetically by name
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Trigger chosen update after data is loaded
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="salaryScaleGroup"]').trigger('chosen:updated');
                }
            }, 0);
        });

        if(this.timezone.dayOfWeek != null) {
            this.type = this.types[1]
        } 
        else if (this.timezone.fixedDateWithoutYear) {
            this.type = this.types[2]
        }
        else if (this.timezone.fixedDate) {
            this.type = this.types[3]
        }
        else {
            this.type = this.types[0]
        }

        this.from.weekDay = this.weekDays[this.timezone.dayOfWeek];
        this.from.day = parseInt(moment(this.timezone.from).format("DD"));
        this.from.month = this.months[parseInt(moment(this.timezone.from).format("MM")) - 1];
        this.from.year = moment(this.timezone.from).format("YYYY");
        this.from.time = moment(this.timezone.from).format("HH:mm");

        this.till.weekDay = this.weekDays[this.timezone.dayOfWeek];
        this.till.day = parseInt(moment(this.timezone.till).format("DD"));
        this.till.month = this.months[parseInt(moment(this.timezone.till).format("MM")) - 1];
        this.till.year = moment(this.timezone.till).format("YYYY");
        this.till.time = moment(this.timezone.till).format("HH:mm");
    }

    submitTimezone() {
        // this.timezone.from = moment(this.timezone.from).format("YYYY-MM-DD HH:mm");
        // this.timezone.till = moment(this.timezone.till).format("YYYY-MM-DD HH:mm");

        var fromDay = this.from.day < 10 ? '0' + this.from.day : this.from.day;
        var fromMonth = this.months.indexOf(this.from.month) + 1 < 10 ? '0' + (this.months.indexOf(this.from.month) + 1) : this.months.indexOf(this.from.month) + 1;

        var tillDay = this.till.day < 10 ? '0' + this.till.day : this.till.day;
        var tillMonth = this.months.indexOf(this.till.month) + 1 < 10 ? '0' + (this.months.indexOf(this.till.month) + 1) : this.months.indexOf(this.till.month) + 1;


        var fts = this.from.time.split(':')
        var fromtimehour = fts[0] < 10 && fts[0].length < 2 ?  '0' + fts[0] : fts[0];
        var fromtime = fromtimehour + ':' + fts[1] + ':00'

        var tts = this.till.time.split(':')
        var tilltimehour = tts[0] < 10 && tts[0].length < 2 ?  '0' + tts[0] : tts[0];
        var tilltime = tilltimehour + ':' + tts[1] + ':00'

        if(this.type == this.types[0]) {
            this.timezone.from = '1900-01-01T' + fromtime
            this.timezone.till = '1900-01-01T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }

        if(this.type == this.types[1]) {
            this.timezone.from = '1900-01-01T' + fromtime
            this.timezone.till = '1900-01-01T' + tilltime
            this.timezone.dayOfWeek = this.weekDays.indexOf(this.from.weekDay);
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }

        if(this.type == this.types[2]) {
            this.timezone.from = '1900-'+ fromMonth +'-'+ fromDay +'T' + fromtime
            this.timezone.till = '1900-'+ tillMonth +'-'+ tillDay +'T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = true;
        }

        if(this.type == this.types[3]) {
            this.timezone.from = this.from.year +'-'+ fromMonth +'-'+ fromDay +'T' + fromtime
            this.timezone.till = this.from.year +'-'+ tillMonth +'-'+ tillDay +'T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = false;
        }


        if (this.timezone.id === undefined) {
            this.TimezonesService.post(this.timezone).then((result: any) => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.timezone.salaryScaleGroupId || this.$stateParams['caoId'];
                this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        } else {
            this.TimezonesService.put(this.timezone.id, this.timezone).then(result => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.timezone.salaryScaleGroupId;
                this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        }
    }

    deleteTimezone() {
        this.SweetAlert.swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.TimezonesService.delete(this.timezone.id).then(() => {
                    this.$state.go('^', {reload: true});
                });
            } else {

            }
        });
    }

    startDateBeforeRender($dates) {
        // console.log('startDateBeforeRender');
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0,0,0,0);
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.timezone.from) {
            var activeDate = moment(this.timezone.from).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    private loadHourCodes = (salaryScaleGroupId: string) => {
        this.HourCodeService.getBySalaryScaleGroupIdForTimezones(salaryScaleGroupId).then((result: IHourCode[]) => {
            this.hourCodes = result || [];
            // Trigger chosen update
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="hourCode"]').trigger('chosen:updated');
                }
            }, 0);
        });
    }

    public watchSalaryScaleGroup = () => {
        if (this.timezone && this.timezone.salaryScaleGroupId) {
            this.loadHourCodes(this.timezone.salaryScaleGroupId);
        } else {
            this.hourCodes = [];
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="hourCode"]').trigger('chosen:updated');
                }
            }, 0);
        }
    }

    public closeModal = () => {
        // Preserve selected CAO when closing modal
        const selectedCaoId = this.timezone.salaryScaleGroupId || this.$stateParams['caoId'];
        
        // Navigate back to list with selected CAO preserved
        this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId || null }, { reload: false });
    }
}

export const timezonesItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: TimezonesItemBasicController,
    template: require('./timezones.item.basic.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.item.basic.component.ts